import React from 'react';
import { useTranslation } from 'react-i18next';
import { getProgressionLevels, getLevelLabel } from '../../utils/progression';

const LEVEL_JUMPS = [-1, -5, -10, 1, 5, 10];
const JUMP_BUTTON_STYLE = {
  flex: 1,
  background: 'linear-gradient(90deg, #e8a8b8 0%, #e899b3 100%)',
  fontSize: '0.9rem',
  padding: '0.6rem'
};

const LevelSettings = ({ currentLevelIndex, onLevelChange }) => {
  const { t } = useTranslation();
  const levels = getProgressionLevels();

  const handleLevelJump = (jump) => {
    const newIndex = Math.max(0, Math.min(99, currentLevelIndex + jump));
    if (newIndex !== currentLevelIndex) {
      onLevelChange(newIndex);
    }
  };

  return (
    <div className="pretty-section settings-section">
      <div className="pretty-label" style={{ marginBottom: '1rem' }}>
        {t('set_level')}: {currentLevelIndex + 1} ({getLevelLabel(currentLevelIndex)})
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
        <button
          className="pretty-btn"
          style={{
            width: '50px',
            background: currentLevelIndex === 0 ? '#ccc' : 'linear-gradient(90deg, #f8bfcf 0%, #f7a8c7 100%)',
            cursor: currentLevelIndex === 0 ? 'not-allowed' : 'pointer'
          }}
          onClick={() => {
            if (currentLevelIndex > 0) {
              onLevelChange(currentLevelIndex - 1);
            }
          }}
          disabled={currentLevelIndex === 0}
        >
          -
        </button>
        <div style={{
          flex: 1,
          background: '#fff0f6',
          border: '1px solid #f8bfcf',
          borderRadius: '8px',
          padding: '0.8rem',
          textAlign: 'center',
          color: '#b85b7b',
          fontWeight: '600'
        }}>
          {t('level_x_of_y', { x: currentLevelIndex + 1, y: 100 })}
          <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '0.2rem' }}>
            {t('total_reps', { count: levels[currentLevelIndex]?.totalReps || 0 })}
          </div>
          <div style={{ fontSize: '0.75rem', color: '#999', marginTop: '0.1rem' }}>
            {t('sets')}: {levels[currentLevelIndex]?.reps.join(', ') || ''}
          </div>
        </div>
        <button
          className="pretty-btn"
          style={{
            width: '50px',
            background: currentLevelIndex >= 99 ? '#ccc' : 'linear-gradient(90deg, #f8bfcf 0%, #f7a8c7 100%)',
            cursor: currentLevelIndex >= 99 ? 'not-allowed' : 'pointer'
          }}
          onClick={() => {
            if (currentLevelIndex < 99) {
              onLevelChange(currentLevelIndex + 1);
            }
          }}
          disabled={currentLevelIndex >= 99}
        >
          +
        </button>
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        {LEVEL_JUMPS.map(jump => (
          <button
            key={jump}
            className="pretty-btn"
            style={JUMP_BUTTON_STYLE}
            onClick={() => handleLevelJump(jump)}
          >
            {jump > 0 ? `+${jump}` : jump}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LevelSettings;
